<template>
  <button
    class="cf-header__account-button"
    type="button"
    title="My Account"
    @click="handleButtonClick"
  >
    <span class="cf-icon far fa-user-circle" />
  </button>
</template>


<script>
  import { mapGetters } from 'vuex';

  import events from '@/services/events';

  export default {
    name: 'CfAccountButton',

    computed: {
      ...mapGetters('offers', ['loyalty', 'rewardCount']),
      ...mapGetters('merchant', ['loyaltyOptions']),
      ...mapGetters('session', ['currentUser'])
    },

    methods: {
      handleButtonClick() {
        if (this.currentUser.accountId) {
          if (this.loyalty.isEnrolled) {
            this.$router.push({
              name: 'loyalty',
              params: {
                merchantId: this.$route.params.merchantId
              }
            });
          }

          else if (this.loyaltyOptions.loyaltyEnrollmentEnabled) {
            events.emit('enroll-in-loyalty:open', {
              forceOpen: true
            });
          }

          else {
            this.$router.push({
              name: 'myAccount',
              params: {
                merchantId: this.$route.params.merchantId
              }
            });
          }
        }

        else {
          this.$openModal('createAccount');
        }
      }
    }
  };
</script>

